import React from "react";
import Button from "@hui/_atoms/button/Button";
import Subheading from "@hui/_atoms/subheading/Subheading";
import Paragraph from "@hui/_atoms/paragraph/Paragraph";
import I18n from "../../../utilities/translations";
import { postResendConfirmationEmail, postResendConfirmationEmailProgress } from "../../../API/onboarding/resend_confirmation_email.api";
import handleError from "../../../API/utils/handleError";
import { getUserEmail } from "../../../utilities/user_attributes";
import FormWrapper from "./Shared/FormWrapper";
import FormBody from "./Shared/FormBody";
import FormButton from "./Shared/FormButton";

const ResendConfirmationEmailForm = ({stateUpdate} : {stateUpdate: (...args) => void}) => {

  const onEmailSubmit = async (e) => {
    e.preventDefault();

    try {
      // We are calling the Auth::ConfirmationsController which does not return a json response so the body will be empty
      await postResendConfirmationEmail(getUserEmail())
      toastr.info(`Confirmation email sent to ${getUserEmail()}`)
    } catch (err) {
      toastr.error("Something went wrong, please try again");
    }
  }
  const ctx = { scope: "onboarding.v3.resend_confirmation_email" };

  const onSubmit = async (e) => {
    e.preventDefault();

    try {
      const res = await postResendConfirmationEmailProgress()
      if (res.status === "ok") {
        stateUpdate(res.data.state)}
      else {
        handleError(res)
      }
    } catch (err) {
      if (err.message === "Error: Unprocessable Content")
        toastr.error("Email address not confirmed, please try again");
      else {
        throw err
      }
    }
  }
  return (<>
    <FormWrapper>
      <form onSubmit={onSubmit} className="tw-flex tw-flex-col tw-flex-1 tw-overflow-hidden">
        <FormBody>
          <Subheading>{I18n.t("title", ctx)}</Subheading>
          <Paragraph>{I18n.t("paragraph_1", { ...ctx, email_address: getUserEmail()})}</Paragraph>
          <Paragraph>{I18n.t("paragraph_2", ctx)}</Paragraph>
          <Button
            type="button"
            onClick={onEmailSubmit}
            variant="secondary"
            classes="tw-w-full tw-mt-4"
          >
            Resend email
          </Button>
        </FormBody>
        <FormButton>
          <div className="md:tw-pb-4">
            <input type="submit" title="next" value="Next" className="hnry-button hnry-button--primary tw-w-full"/>
          </div>
        </FormButton>
      </form>
    </FormWrapper>
  </>
  )
}
export default ResendConfirmationEmailForm